(function () {
  const env = { "NODE_ENV": "production" };
  try {
    if (process) {
      process.env = Object.assign({}, process.env);
      Object.assign(process.env, env);
      return;
    }
  } catch (e) { } // avoid ReferenceError: process is not defined
  globalThis.process = { env: env };
})();
